import { defineStore } from 'pinia';
import { ref } from 'vue';

import { fetchPspWarningSettings } from '@/api/settings';
import type { PspWarningSettings } from '@/types';

export const useSettingsStore = defineStore('settings', () => {
  const pspWarningSettings = ref<PspWarningSettings | null>(null);

  async function fetchSettings() {
    pspWarningSettings.value = await fetchPspWarningSettings();
  }

  return {
    pspWarningSettings,
    fetchSettings,
  };
});
